<template>
  <div>
    <headerSection :mainMenu="mainMenu"></headerSection>
    <div id="main__content" class="x-homepage -sticky">
<div class="x-cover x-index-event-container">
            <img src="../assets/images/cover-slot-bg.jpg" class="-bg" alt="สูตรสล็อต สูตรบาคาร่า เจ้าแรกในไทย ผ่านเว็บตรง xxmac">
        <!-- <img src="../assets/images/cover-slot-bg-mobile.png" class="-bg -mobile" alt="สูตรสล็อต สูตรบาคาร่า เจ้าแรกในไทย ผ่านเว็บตรง xxmac"> -->
        <div class="container-fluid -bg">
            <div class="row -contents-wrapper">
                <div class="col-12 col-md-6 -left-content"></div>
                <div class="col-12 col-md-6 -right-content bg-mobile" >
                  <div data-slickable="{&quot;fade&quot;:true,&quot;arrows&quot;:false,&quot;autoplay&quot;:true,&quot;infinite&quot;:true,&quot;pauseOnHover&quot;:false,&quot;adaptiveHeight&quot;:true,&quot;slidesToShow&quot;:1,&quot;autoplaySpeed&quot;:5000}" data-animatable="fadeInUp" data-delay="200" class="slick-initialized slick-slider animated fadeInUp">
                                                    <div class="slick-list draggable" style="height: 58px;"><div class="slick-track" style="opacity: 1; width: 100%;top:5px;display: flex;justify-content: flex-end;float: right;"><div class="slick-slide slick-current slick-active resize bg-mobile2" data-slick-index="0" aria-hidden="false" style="position: relative; right: 0; top: 0px; z-index: 999; opacity: 1;">
                                                                    <h1 class="-title">จัดหนักจัดเต็มกับการจัดกิจกรรม  <br>  และสิทธิพิเศษสุดคุ้ม</h1>
                                                                <p class="-sub-title">กิจกรรมมากที่สุดในไทย มีให้นักเดิมพันได้ร่วมสนุกทุกวัน</p>
                                <div class="-btn-wrapper d-none animated fadeInUp" data-animatable="fadeInUp" data-delay="500">
                                    <a href="javascript:void(0)" class="btn -register-btn order-0" data-toggle="modal" data-target="#registerModal" tabindex="0">
    <span class="-btn-title">สมัครสมาชิก</span>
</a>
                                </div>
                            </div></div></div>

                                            </div>
                </div>
            </div>
        </div>

    </div>

<section class="x-category-index -v2">
        <div class="-nav-menu-container js-category-menus -sticky">
            <nav class="nav-menu" id="navbarCategory">
                <ul class="-menu-parent navbar-nav js-menu-container" id="accordion-games">

                  <li class="-list-parent nav-item" v-if="user.key">
                    <div class="d-lg-block d-none">
                    <router-link to="/favorite" :class="{'x-category-button':true, '-category-favorite':true, 'active':(mainMenu === 'favorite')?true:false, '-category-button-v2':true, '-hoverable':true}">
                        <picture>
                            <source type="image/png?v=1" srcset="../assets/images/menu/category-favorite.png?v=1">
                            <img alt=" cover image png" class="-img -default" src="../assets/images/menu/category-favorite.png?v=1">
                        </picture>
                        <picture>
                            <source type="image/png?v=1" srcset="../assets/images/menu/category-favorite-hover.png?v=1">
                            <img alt=" cover image png" class="-img -hover" src="../assets/images/menu/category-favorite-hover.png?v=1">
                        </picture>
                        <!-- <span class="-menu-text-main -text-btn-image">
                            ยอดนิยม
                        </span> -->
                    </router-link>
                    </div>
                    <div class="d-lg-none d-block w-100">
                      <router-link to="/favorite" :class="{'x-category-button':true, '-category-favorite':true, 'active':(mainMenu === 'favorite')?true:false, '-category-button-v2':true, '-hoverable':true}">
                          <picture>
                              <source type="image/png?v=1" srcset="../assets/images/menu/favorite.png">
                              <img alt="cover image png" class="-img-mobile" src="../assets/images/menu/favorite.png">
                          </picture>
                          <span class="-menu-text-main -text-btn-image" style="font">
                              เกมส์โปรด
                          </span>
                      </router-link>
                    </div>
                  </li>

                  <li class="-list-parent nav-item">
                    <div class="d-lg-block d-none">
                    <router-link to="/hotgames" :class="{'x-category-button':true, '-category-popular':true, 'active':(mainMenu === 'hotgames')?true:false, '-category-button-v2':true, '-hoverable':true}">
                        <picture>
                            <source type="image/png?v=1" srcset="../assets/images/menu/category-popular.png?v=1">
                            <img alt=" cover image png" class="-img -default" src="../assets/images/menu/category-popular.png?v=1">
                        </picture>
                        <picture>
                            <source type="image/png?v=1" srcset="../assets/images/menu/category-popular-hover.png?v=1">
                            <img alt=" cover image png" class="-img -hover" src="../assets/images/menu/category-popular-hover.png?v=1">
                        </picture>
                        <!-- <span class="-menu-text-main -text-btn-image">
                            ยอดนิยม
                        </span> -->
                    </router-link>
                    </div>

                    <div class="d-lg-none d-block w-100">
                      <router-link to="/hotgames" :class="{'x-category-button':true, '-category-popular':true, 'active':(mainMenu === 'hotgames')?true:false, '-category-button-v2':true, '-hoverable':true}">
                          <picture>
                              <source type="image/png?v=1" srcset="../assets/images/menu/hot.png">
                              <img alt="cover image png" class="-img-mobile" src="../assets/images/menu/hot.png">
                          </picture>
                          <span class="-menu-text-main -text-btn-image">
                              ยอดนิยม
                          </span>
                      </router-link>
                    </div>
                  </li>

    <li class="-list-parent nav-item">

    <div class="d-lg-block d-none">
        <router-link to="/newgames" :class="{'x-category-button':true, '-category-new-released':true,  '-category-button-v2':true, '-hoverable':true, 'active':(mainMenu === 'newgames')?true:false}">
                <picture><source type="image/webp" srcset="../assets/images/menu/category-new-released.png"><source type="image/png?v=1" srcset="../assets/images/menu/category-new-released.png?v=1"><img alt=" cover image png" class="-img -default" src="../assets/images/menu/category-new-released.png?v=1"></picture>
                <picture><source type="image/webp" srcset="../assets/images/menu/category-new-released-hover.png"><source type="image/png?v=1" srcset="../assets/images/menu/category-new-released-hover.png?v=1"><img alt=" cover image png" class="-img -hover" src="../assets/images/menu/category-new-released-hover.png?v=1"></picture>
                <!-- <span class="-menu-text-main -text-btn-image">
                    เกมใหม่
                </span> -->
        </router-link>
    </div>

    <div class="d-lg-none d-block w-100">
        <router-link to="/newgames" :class="{'x-category-button':true, '-category-new-released':true,  '-category-button-v2':true, '-hoverable':true, 'active':(mainMenu === 'newgames')?true:false}">
                <picture><source type="image/webp" srcset="../assets/images/menu/new-game.png"><source type="image/png?v=1" srcset="../assets/images/menu/new-game.png"><img alt="cover image png" class="-img-mobile" src="../assets/images/menu/new-game.png"></picture>
                <span class="-menu-text-main -text-btn-image">
                    เกมใหม่
                </span>
        </router-link>
    </div>
    </li>
    <li class="-list-parent nav-item">
        <router-link to="/provider" :class="{'x-category-button':true, 'd-lg-none':true, 'js-brand':true, '-category-brand':true,  '-category-button-v2':true, '-hoverable':true, 'active':(mainMenu === 'provider')?true:false}">
                <picture><source type="image/webp" srcset="../assets/images/menu/slot.png"><source type="image/png?v=1" srcset="../assets/images/menu/slot.png"><img alt="cover image png" class="-img-mobile" src="../assets/images/menu/slot.png"></picture>
                <span class="-menu-text-main -text-btn-image">
                    สล๊อต
                    <i class="fas fa-caret-down d-none d-lg-flex"></i>
                </span>
        </router-link>
        <a href="#0" data-toggle="collapse" data-target="#collapse-brand" aria-expanded="false" aria-controls="collapse-brand" :class="{'active':(mainMenu === 'provider')?true:false,'x-category-button -is-collapse -category-brand collapsed js-brand d-lg-flex d-none -category-button-v2 -hoverable':true}" @click="showGame('provider')">
                <picture><source type="image/webp" srcset="../assets/images/menu/category-brand.png"><source type="image/png?v=1" srcset="../assets/images/menu/category-brand.png?v=1"><img alt=" cover image png" class="-img -default" src="../assets/images/menu/category-brand.png?v=1"></picture>
                <picture><source type="image/webp" srcset="../assets/images/menu/category-brand-hover.png"><source type="image/png?v=1" srcset="../assets/images/menu/category-brand-hover.png?v=1"><img alt=" cover image png" class="-img -hover" src="../assets/images/menu/category-brand-hover.png?v=1"></picture>
                <span class="-menu-text-main -text-btn-image">
                    <i class="fas fa-caret-down d-none d-lg-flex"></i>
                </span>
        </a>

        <div class="d-lg-block d-none">
            <div id="collapse-brand" :class="{'x-menu-collapse-container':true, '-category-brand':true, 'collapse':true, 'show':(provider && mainMenu ==='provider')?true:false}" data-parent="#accordion-games">
                <template v-for="(item) in slotbrands">
                    <button type="button" :class="{'btn-block':true, '-child-collapse':true, 'active':(provider && provider === item.provider)?true:false}" @click="gotoProvider('provider',item.provider)">
                        <picture v-if="item.image.horizontal">
                            <source type="image/png" :srcset="item.image.horizontal">
                            <img :alt="item.providerName" class="img-fluid -img-btn" width="162" v-lazy="item.image.horizontal">
                        </picture>
                        <picture v-else>
                          <source type="image/png" :srcset="item.logoMobileURL">
                          <img :alt="item.providerName" class="img-fluid -img-btn" width="162" v-lazy="item.logoMobileURL">
                        </picture>
                    </button>
                </template>
            </div>
        </div>
    </li>
    <li class="-list-parent nav-item">
        <div class="d-lg-block d-none">
            <router-link to="/casino" :class="{'x-category-button -category-casino -category-button-v2 -hoverable':true, 'active':(mainMenu === 'casino')?true:false}">
                <picture><source type="image/webp" srcset="../assets/images/menu/category-casino.png"><source type="image/png?v=1" srcset="../assets/images/ez-slot-category-casino.png?v=1"><img alt=" cover image png" class="-img -default" src="../assets/images/ez-slot-category-casino.png?v=1"></picture>
                <picture><source type="image/webp" srcset="../assets/images/menu/category-casino-hover.png"><source type="image/png?v=1" srcset="../assets/images/ez-slot-category-casino-hover.png?v=1"><img alt=" cover image png" class="-img -hover" src="../assets/images/ez-slot-category-casino-hover.png?v=1"></picture>
                <!-- <span class="-menu-text-main -text-btn-image">
                    คาสิโนสด
                </span> -->
            </router-link>
        </div>
        <div class="d-lg-none d-block w-100">
            <router-link to="/casino" :class="{'x-category-button -category-casino -category-button-v2 -hoverable':true, 'active':(mainMenu === 'casino')?true:false}">
                <picture><source type="image/webp" srcset="../assets/images/menu/casino.png"><source type="image/png?v=1" srcset="../assets/images/menu/casino.png"><img alt="cover image png" class="-img-mobile" src="../assets/images/menu/casino.png"></picture>
                <span class="-menu-text-main -text-btn-image">
                    คาสิโนสด
                </span>
            </router-link>
        </div>
    </li>
    <li class="-list-parent nav-item">
        <router-link to="/fish" :class="{'x-category-button':true, 'd-lg-none':true, 'js-brand':true, '-category-brand':true,  '-category-button-v2':true, '-hoverable':true, 'active':(mainMenu === 'fish')?true:false}">
                <picture><source type="image/webp" srcset="../assets/images/menu/fish.png"><source type="image/png?v=1" srcset="../assets/images/menu/fish.png"><img alt="cover image png" class="-img-mobile" src="../assets/images/menu/fish.png"></picture>
                <span class="-menu-text-main -text-btn-image">
                    ยิงปลา
                    <i class="fas fa-caret-down d-none d-lg-flex"></i>
                </span>
        </router-link>
        <a href="#0" data-toggle="collapse" data-target="#collapse-fish" aria-expanded="false" aria-controls="collapse-fish" :class="{'active':(mainMenu === 'fish')?true:false,'x-category-button -is-collapse -category-brand collapsed js-brand d-lg-flex d-none -category-button-v2 -hoverable':true}" @click="showGame('fish')">
                <picture><source type="image/webp" srcset="../assets/images/menu/category-fishing-game.png"><source type="image/png?v=1" srcset="../assets/images/menu/category-fishing-game.png"><img alt=" cover image png" class="-img -default" src="../assets/images/menu/category-fishing-game.png"></picture>
                <picture><source type="image/webp" srcset="../assets/images/menu/category-fishing-game-hover.png"><source type="image/png?v=1" srcset="../assets/images/menu/category-fishing-game-hover.png"><img alt=" cover image png" class="-img -hover" src="../assets/images/menu/category-fishing-game-hover.png"></picture>
                <span class="-menu-text-main -text-btn-image">
                    <i class="fas fa-caret-down d-none d-lg-flex"></i>
                </span>
        </a>

        <div class="d-lg-block d-none">
            <div id="collapse-fish" :class="{'x-menu-collapse-container':true, '-category-brand':true, 'collapse':true, 'show':(provider && mainMenu ==='fish')?true:false}" data-parent="#accordion-games">
                <template v-for="(item) in fishgames">
                    <button type="button" :class="{'btn-block':true, '-child-collapse':true, 'active':(provider && provider === item.provider)?true:false}" @click="gotoProvider('fish',item.provider)">
                        <picture>
                            <source type="image/png" :srcset="item.image.horizontal">
                            <img alt="pgsoft" class="img-fluid -img-btn" width="162" v-lazy="item.image.horizontal">
                        </picture>
                    </button>
                </template>
            </div>
        </div>
    </li>

                        <li class="-list-parent nav-item">

                                                                    <div class="d-lg-block d-none">

<a href="/playsport" target="_blank" class="x-category-button -category-sport -category-button-v2 -hoverable ">

            <picture><source type="image/webp" srcset="../assets/images/menu/category-sport.png"><source type="image/png?v=1" srcset="../assets/images/menu/category-sport.png?v=1"><img alt=" cover image png" class="-img -default" src="../assets/images/menu/category-sport.png?v=1"></picture>

            <picture><source type="image/webp" srcset="../assets/images/menu/category-sport-hover.png"><source type="image/png?v=1" srcset="../assets/images/menu/category-sport-hover.png?v=1"><img alt=" cover image png" class="-img -hover" src="../assets/images/menu/category-sport-hover.png?v=1"></picture>

    <!-- <span class="-menu-text-main -text-btn-image">
        สปอร์ต
            </span> -->

    </a>
                                    </div>

                                    <div class="d-lg-none d-block w-100">

<a href="/playsport" target="_blank" class="x-category-button -category-sport -category-button-v2 -hoverable ">

            <picture><source type="image/webp" srcset="../assets/images/menu/sport.png"><source type="image/png?v=1" srcset="../assets/images/menu/sport.png"><img alt="cover image png" class="-img-mobile" src="../assets/images/menu/sport.png"></picture>

    <span class="-menu-text-main -text-btn-image">
        สปอร์ต
            </span>

    </a>
                                    </div>
                                                                                    </li>

                        <li class="-list-parent nav-item">

                                                                    <div class="d-lg-block d-none">
<router-link to="/card" :class="{'x-category-button':true, 'd-lg-none':true, 'js-brand':true, '-category-brand':true,  '-category-button-v2':true, '-hoverable':true, 'active':(mainMenu === 'card')?true:false}">

            <picture><source type="image/webp" srcset="../assets/images/menu/category-skill-game.png"><source type="image/png?v=1" srcset="../assets/images/menu/category-skill-game.png?v=1"><img alt=" cover image png" class="-img -default" src="../assets/images/menu/category-skill-game.png?v=1"></picture>

            <picture><source type="image/webp" srcset="../assets/images/menu/category-skill-game-hover.png"><source type="image/png?v=1" srcset="../assets/images/menu/category-skill-game-hover.png?v=1"><img alt=" cover image png" class="-img -hover" src="../assets/images/menu/category-skill-game-hover.png?v=1"></picture>

    <!-- <span class="-menu-text-main -text-btn-image">
        สกิลเกมส์
            </span> -->

    </router-link>
                                    </div>

                                    <div class="d-lg-none d-block w-100">
    <router-link to="/card" :class="{'x-category-button -category-casino -category-button-v2 -hoverable':true, 'active':(mainMenu === 'card')?true:false}">
            <picture><source type="image/webp" srcset="../assets/images/menu/card.png"><source type="image/png?v=1" srcset="../assets/images/menu/card.png"><img alt="cover image png" class="-img-mobile" src="../assets/images/menu/card.png"></picture>
    <span class="-menu-text-main -text-btn-image">
        เกมส์ไพ่
            </span>
   </router-link>
                                    </div>
                                                                                    </li>

        <!-- <li class="-list-parent nav-item">
            <div class="d-lg-block d-none">
                <router-link to="/fish" :class="{'active':(mainMenu === 'fish')?true:false,'x-category-button -category-fishing-game -category-button-v2 -hoverable':true}">
                    <picture><source type="image/webp" srcset="../assets/images/ez-slot-category-fishing-game.png"><source type="image/png?v=1" srcset="../assets/images/ez-slot-category-fishing-game.png?v=1"><img alt=" cover image png" class="-img -default" src="../assets/images/ez-slot-category-fishing-game.png?v=1"></picture>
                    <picture><source type="image/webp" srcset="../assets/images/ez-slot-category-fishing-game-hover.png"><source type="image/png?v=1" srcset="../assets/images/ez-slot-category-fishing-game-hover.png?v=1"><img alt=" cover image png" class="-img -hover" src="../assets/images/ez-slot-category-fishing-game-hover.png?v=1"></picture>
                    <span class="-menu-text-main -text-btn-image">
                        ยิงปลา
                    </span>
                </router-link>
            </div>
            <div class="d-lg-none d-block w-100">
                <router-link to="/fish" :class="{'active':(mainMenu === 'fish')?true:false,'x-category-button -category-fishing-game -category-button-v2 -hoverable':true}">
                    <picture><source type="image/webp" srcset="../assets/images/ez-slot-category-fishing-game-mobile.png"><source type="image/png?v=1" srcset="../assets/images/ez-slot-category-fishing-game-mobile.png?v=1"><img alt="cover image png" class="-img-mobile" src="../assets/images/ez-slot-category-fishing-game-mobile.png?v=1"></picture>
                    <span class="-menu-text-main -text-btn-image">
                        ยิงปลา
                    </span>
                </router-link>
            </div>
        </li> -->
    </ul>
                <div class="d-lg-none">
                    <div class="-menu-parent -menu-mobile navbar-nav js-menu-container-mobile">
                        <div class="-list-parent">
                        </div>
                    </div>
                </div>
            </nav>
        </div>
        <div class="class-for-mobile x-index-content-main-container pb-4 -anon">
          <div class="-slot-games-list-container animated fadeInUp" data-animatable="fadeInUp" data-delay="150">
          <ul class="navbar-nav">
              <li v-if="mainMenu==='provider' && slotbrands && slotbrands.length" v-for="(item,index) in slotbrands" :class="{'nav-item':true,'-first':(index === 0)?true:false}">
                  <div class="x-game-list-item-macro js-game-list-toggle -big -cannot-entry -untestable" data-status="-cannot-entry -untestable">
                      <div class="-inner-wrapper">
                          <router-link :to="'/provider/'+item.provider" class="-btn -btn-play">
                              <picture>
                                  <source type="image/png" :data-srcset="item.image.vertical" :srcset="item.image.vertical">
                                  <img class="-cover-img img-fluid lazyloaded" alt="wt-pg-soft cover image png" :data-src="item.image.vertical" :src="item.image.vertical">
                              </picture>
                          </router-link>
                      </div>
                  </div>
              </li>
              <li v-if="mainMenu==='fish' && fishgames && fishgames.length" v-for="(item,index) in fishgames" :class="{'nav-item':true,'-first':(index === 0)?true:false}">
                  <div class="x-game-list-item-macro js-game-list-toggle -big -cannot-entry -untestable" data-status="-cannot-entry -untestable">
                      <div class="-inner-wrapper">
                          <router-link :to="'/fish/'+item.provider" class="-btn -btn-play">
                              <picture>
                                  <source type="image/png" :data-srcset="item.image.vertical" :srcset="item.image.vertical">
                                  <img class="-cover-img img-fluid lazyloaded" alt="wt-pg-soft cover image png" :data-src="item.image.vertical" :src="item.image.vertical">
                              </picture>
                          </router-link>
                      </div>
                  </div>
              </li>
          </ul>
      
          </div>
          <!-- <VueSlickCarousel v-if="mainMenu==='provider' && slotbrands && slotbrands.length" v-bind="settings" style="padding-top:10px;">
            <div v-for="(item) in slotbrands"><a href="javascript:void(0)" @click="gotoProvider('provider',item.provider)" :class="{'nav-link js-side-pgsoft-btn':true,'-active':(provider && provider === item.provider)?true:false}"><img class="img-fluid -img-btn" height="150" v-lazy="item.image.horizontal"></a></div>
          </VueSlickCarousel>
          <VueSlickCarousel v-if="mainMenu==='fish' && fishgames && fishgames.length" v-bind="settings" style="padding-top:10px;">
            <div v-for="(item) in fishgames"><a href="javascript:void(0)" @click="gotoProvider('fish',item.provider)" :class="{'nav-link js-side-pgsoft-btn':true,'-active':(provider && provider === item.provider)?true:false}"><img class="img-fluid -img-btn" height="150" v-lazy="item.image.horizontal"></a></div>
          </VueSlickCarousel> -->
        </div>
        <div class="-games-list-outer-container">
            <div v-if="mainMenu==='provider'" :class="{'x-menu-mobile-sidebar-wrapper':true,'d-none':true}" style="position: relative;">
                <div data-menu-sticky="js-sticky-widget" class="js-sticky-widget" style="width: auto; height: auto; top: 22px; bottom: 0px;">
                    <ul class="nav -menu-list">
                        <li v-for="(item) in slotbrands" class="nav-item">
                                <a href="javascript:void(0)" @click="gotoProvider('provider',item.provider)" :class="{'nav-link js-side-pgsoft-btn':true,'-active':(provider && provider === item.provider)?true:false}">
                                    <picture><source type="image/webp" :srcset="item.image.horizontal"><source type="image/png" :srcset="item.image.horizontal"><img alt="pgsoft" class="img-fluid -img-btn" height="50" v-lazy="item.image.horizontal"></picture>
                                </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div v-if="mainMenu==='fish'" :class="{'x-menu-mobile-sidebar-wrapper':true,'d-none':true}" style="position: relative;">
                <div data-menu-sticky="js-sticky-widget" class="js-sticky-widget" style="width: auto; height: auto; /*position: absolute;*/ top: 22px; bottom: 0px;">
                    <ul class="nav -menu-list">
                        <li v-for="(item) in fishgames" class="nav-item">
                                <a href="javascript:void(0)" @click="gotoProvider('fish',item.provider)" :class="{'nav-link js-side-pgsoft-btn':true,'-active':(provider && provider === item.provider)?true:false}">
                                    <picture><source type="image/webp" :srcset="item.image.horizontal"><source type="image/png" :srcset="item.image.horizontal"><img alt="pgsoft" class="img-fluid -img-btn" height="50" v-lazy="item.image.horizontal"></picture>
                                </a>
                            </li>
                    </ul>
                </div>
            </div>
            <div class="-games-list-container js-game-scroll-container js-game-container col">

<div class="-games-list-wrapper">
    <div class="-game-title-wrapper">
        <div class="-game-title-inner">
            <h2 class="-game-title h3">
                {{this.title}}
                <span class="-sub-title">({{(games)?games.length:0}} Games)</span>
            </h2>
        </div>
    </div>
    <div class="-game-search-inner">
            <div class="input-group x-search-component -v2">
                <input type="text" id="searchKeyword" v-model="search" name="search" value="" class="x-form-control form-control -form-search-input" placeholder="ค้นหาเกมส์หรือค่ายเกมส์..." @keyup="searchData()">
                <div class="input-group-prepend">
                    <div class="input-group-text -text-group-wrapper" id="btnGroupAddon">
                        <button class="btn btn-primary -btn-search ">
                        <i class="fas fa-search"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    <ul class="navbar-nav">
        <li class="nav-item" v-for="(item) in games">
            <div class="x-game-list-item-macro js-game-list-toggle -big " data-status="">
                <div class="-inner-wrapper">
                    <!-- <div class="x-game-video-component animated fadeInUp" data-animatable="fadeInUp" data-delay="300">
                        <a class="-video-btn" data-slot-video-example="https://ezslot-video.s3-ap-southeast-1.amazonaws.com/wt-pg-soft_rooster-rbl.mp4" href="#see-vdo-rooster-rbl">
                            <img src="../assets/images/ez-slot-ic-video-example.png" class="-ic-video-example img-fluid" alt="Ez Slot icon video example">
                        </a>
                        <div class="-content-wrapper">
                            <div class="-content-inside">
                                <span>ดูตัวอย่าง</span>
                            </div>
                        </div>
                    </div> -->
                    <template v-if="user.key">
                      <router-link :to="{ name: 'PlayGame',query: {id: item.id,provider:item.provider,gameCategory:item.gameCategory}}" target="_blank" class="-btn -btn-play js-account-approve-aware">
                        <picture>
                              <source type="image/png?v=1" :data-srcset="item.image.vertical" :srcset="item.image.vertical">
                              <img class="-cover-img img-fluid ls-is-cached lazyloaded" alt="wt-pg-soft cover image png" width="249" height="361" :data-src="item.image.vertical" v-lazy="item.image.vertical">
                          </picture>
                      </router-link>
                    </template>
                    <template v-else>
                      <a href="#loginModal" data-toggle="modal" data-target="#loginModal" class="-btn -btn-play js-account-approve-aware">
                        <picture>
                            <source type="image/png?v=1" :data-srcset="item.image.vertical" :srcset="item.image.vertical">
                            <img class="-cover-img img-fluid ls-is-cached lazyloaded" alt="wt-pg-soft cover image png" width="249" height="361" :data-src="item.image.vertical" v-lazy="item.image.vertical">
                        </picture>
                      </a>
                    </template>

                    <div class="-overlay">
                        <div class="-overlay-inner">
                            <div class="-wrapper-container">
                                <template v-if="user.key">
                                    <router-link :to="{ name: 'PlayGame',query: {id: item.id,provider:item.provider,gameCategory:item.gameCategory}}" target="_blank" class="-btn -btn-play js-account-approve-aware">
                                        <i class="fas fa-play"></i>
                                        <span class="-text-btn">เข้าเล่น</span>
                                    </router-link>
                                    <!-- <a href="javascript:void(0)" @click="playGame(item.id,item.provider,item.gameCategory)" class="-btn -btn-play js-account-approve-aware">
                                        <i class="fas fa-play"></i>
                                        <span class="-text-btn">เข้าเล่น</span>
                                    </a> -->
                                </template>
                                <template v-else>
                                    <a href="#loginModal" data-toggle="modal" data-target="#loginModal" class="-btn -btn-play js-account-approve-aware">
                                        <i class="fas fa-play"></i>
                                        <span class="-text-btn">เข้าเล่น</span>
                                    </a>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    </ul>
        </div>
            </div>
        </div>
    </section>

<!-- <div class="x-modal modal -v2 " id="providerUserModalMobile" tabindex="-1" role="dialog" aria-hidden="true" data-loading-container=".modal-body" data-ajax-modal-always-reload="true" data-ajax-modal="/account/_ajax_/provider-user-info?isMobileView=1" data-container="#providerUserModalMobile">
                            <div class="modal-dialog -modal-size -v2 modal-dialog-centered modal-dialog-scrollable " role="document">
            <div class="modal-content -modal-content">
                                    <button type="button" class="close f-1 " data-dismiss="modal" aria-label="Close">
                        <i class="fas fa-times"></i>
                    </button>
                                                                <div class="modal-body -modal-body">
                                            <div class="js-modal-content"></div>
                                    </div>
            </div>
        </div>
    </div>

<div class="x-modal modal -v2 " id="couponModalMobile" tabindex="-1" role="dialog" aria-hidden="true" data-loading-container=".modal-body" data-ajax-modal-always-reload="true" data-ajax-modal="/account/_ajax_/coupon-apply?isMobileView=1" data-container="#couponModalMobile">
                            <div class="modal-dialog -modal-size -v2 modal-dialog-centered modal-dialog-scrollable " role="document">
            <div class="modal-content -modal-content">
                                    <button type="button" class="close f-1 " data-dismiss="modal" aria-label="Close">
                        <i class="fas fa-times"></i>
                    </button>
                                                                <div class="modal-body -modal-body">
                                            <div class="js-modal-content"></div>
                                    </div>
            </div>
        </div>
    </div>
         -->
<!-- <div class="x-modal modal -v2 " id="joinPromotionModalMobile" tabindex="-1" role="dialog" aria-hidden="true" data-loading-container=".modal-body" data-ajax-modal-always-reload="true" data-ajax-modal="/account/_ajax_/promotion?isMobileView=1" data-container="#joinPromotionModalMobile">
                            <div class="modal-dialog -modal-size -v2 modal-dialog-centered modal-dialog-scrollable " role="document">
            <div class="modal-content -modal-content">
                                    <button type="button" class="close f-1 " data-dismiss="modal" aria-label="Close">
                        <i class="fas fa-times"></i>
                    </button>
                                                                <div class="modal-body -modal-body">
                                            <div class="js-modal-content"></div>
                                    </div>
            </div>
        </div>
    </div> -->

<footerSection></footerSection>

            </div>

</div>
</template>

<script>
import router from './../router'
import firebase from 'firebase/app'
import _ from 'lodash'
// import VueSlickCarousel from 'vue-slick-carousel'
//   import 'vue-slick-carousel/dist/vue-slick-carousel.css'
//   // optional style for arrows & dots
//   import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
  name: 'Main',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue'),
    //VueSlickCarousel
  },
  mounted () {
    this.scrollToElement();
    // Bonn.boots.push(function() {
    //   setTimeout(function() {
    //     $('#bankInfoModal').modal('show');
    //   }, 500);
    // });
    this.mainMenu = (this.$route.name === 'providerName') ? 'provider' : (this.$route.name === 'casinoName') ? 'casino' : (this.$route.name === 'fishName') ? 'fish' : this.$route.name
    this.renderTitleTotalGame()
    // this.$store.dispatch('user/getBanners').catch(err => { console.error(err) })
    // this.checkAnoucement()
  },
  watch: {
    newgames (newData) {
      if (newData) {
        this.renderTitleTotalGame()
      }
    }
  },
  computed: {
    user () {
      return this.$store.state.user.user
    },
    cardgames () {
      return this.$store.state.user.cardGames
    },
    slotbrands () {
      return this.$store.state.user.slotbrands
    },
    hotgames () {
      return this.$store.state.user.hotGames
    },
    newgames () {
      return this.$store.state.user.newGames
    },
    casinos () {
      return this.$store.state.user.casinoGames
    },
    fishgames () {
      return this.$store.state.user.fishgames
    },
    favoritegames () {
      return this.$store.state.user.favoritegames
    },
    swiper () {
      return this.$refs.mySwiper.$swiper
    },
    lastbonus () {
      return this.$store.state.user.lastbonus
    },
    allgames () {
      return this.$store.state.user.allgames
    }
  },
  data () {
    return {
      // settings: {
      //   "centerMode": true,
      //   "centerPadding": "20px",
      //   "focusOnSelect": true,
      //   "infinite": true,
      //   "slidesToShow": 2,
      //   "autoplay": true,
      //   "autoplaySpeed": 2000,
      //   "pauseOnFocus": true,
      //   "pauseOnHover": true,
      //   "speed": 500,
      // },
      page:1,
      games: [],
      provider: '',
      title: '',
      mainMenu: 'slot',
      receiveAnounceMent: false,
      anoucement: {},
      balance: 0,
      fa_spin: false,
      search: '',
      busy: false,
      gamesOrder:[],
    }
  },
  methods: {
    scrollToElement() {
      window.onscroll = () => {
        const body = document.body; const html = document.documentElement;
        const height = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight )
        //let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
        const bottomOfWindow = (document.documentElement.scrollTop + window.innerHeight + document.documentElement.offsetHeight)+500 > height;
        if (bottomOfWindow) {
         this.page++
         this.renderTitleTotalGame()
        }
      }
    },
    searchData () {
      if (this.search && this.allgames) {
        const search = this.search
        const results = _.filter(this.allgames, (obj) => {
          return obj.gameName.toLowerCase().indexOf(search.toString().toLowerCase()) !== -1
        })
        const check = []
        const games = []
        for (const x in results) {
          if (!check[results[x].id]) {
            games.push(results[x])
            check[results[x].id] = true
          }
        }
        this.games = _.orderBy(games, ['gameName'], ['asc'])
      }
    },
    showGame (type) {
      if (type === 'fish') {
        this.title = 'เกมส์ยิงปลาทั้งหมด'
        const games = []
        const check = []
        for (const x in this.fishgames) {
          for (const xx in this.fishgames[x].games) {
            if (!check[this.fishgames[x].games[xx].id]) {
              games.push(this.fishgames[x].games[xx])
              check[this.fishgames[x].games[xx].id] = true
            }
          }
        }
        this.games = _.orderBy(games, ['gameName'], ['asc'])
      } else {
        this.title = 'เกมส์สล๊อตทั้งหมด'
        const games = []
        const check = []
        for (const x in this.slotbrands) {
          for (const xx in this.slotbrands[x].games) {
            if (!check[this.slotbrands[x].games[xx].id]) {
              games.push(this.slotbrands[x].games[xx])
              check[this.slotbrands[x].games[xx].id] = true
            }
          }
        }
        this.games = _.orderBy(games, ['gameName'], ['asc'])
      }
    },
    // mobileCheck () {
    //   let check = false;
    //   (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor || window.opera)
    //   return check
    // },
    // playGame (id, provider, type) {
    //   if (this.user) {
    //     this.$store.commit('user/SET_LOADING', true)
    //     this.$store.dispatch('user/playGame', { user: this.user, id, provider, type, mobile: this.mobileCheck() }).then(res => { this.$store.commit('user/SET_LOADING', false) }).catch(err => { console.error(err) })
    //   }
    // },
    renderTitleTotalGame () {
      if (this.mainMenu === 'favorite') {
        this.title = 'เกมส์โปรด'
        this.games = _.orderBy(this.favoritegames, ['gameName'], ['asc'])
      } else if (this.mainMenu === 'hotgames') {
        this.title = 'เกมส์ยอดนิยม'
        this.games = _.orderBy(this.hotgames, ['gameName'], ['asc'])
      } else if (this.mainMenu === 'newgames') {
        this.title = 'เกมส์ใหม่'
        this.games = _.orderBy(this.newgames, ['gameName'], ['asc'])
      } else if (this.mainMenu === 'casino') {
        if (this.$route.params.provider) {
          this.provider = this.$route.params.provider
        } else {
          this.title = 'คาสิโนทั้งหมด'
        }
        const games = []
        const check = []
        for (const x in this.casinos) {
          if (this.$route.params.provider && this.casinos[x].provider.trim().toLowerCase() === this.$route.params.provider.trim().toLowerCase()) {
            this.title = 'ค่าย ' + this.casinos[x].providerName
            this.games = _.orderBy(this.casinos[x].games, ['gameName'], ['asc'])
            break
          }
          for (const xx in this.casinos[x].games) {
            if (!check[this.casinos[x].games[xx].id]) {
              games.push(this.casinos[x].games[xx])
              check[this.casinos[x].games[xx].id] = true
            }
          }
        }
        if (!this.$route.params.provider) {
          this.games = _.orderBy(games, ['gameName'], ['asc'])
        }
      } else if (this.mainMenu === 'sport') {
        this.title = 'สปอร์ต'
      } else if (this.mainMenu === 'fish') {
        if (this.$route.params.provider) {
          this.provider = this.$route.params.provider
        } else {
          this.title = 'เกมส์ยิงปลาทั้งหมด'
        }
        const games = []
        const check = []
        for (const x in this.fishgames) {
          if (this.$route.params.provider && this.fishgames[x].provider.trim().toLowerCase() === this.$route.params.provider.trim().toLowerCase()) {
            this.title = 'เกมส์ยิงปลาค่าย ' + this.fishgames[x].providerName
            this.games = _.orderBy(this.fishgames[x].games, ['gameName'], ['asc'])
            break
          }
          for (const xx in this.fishgames[x].games) {
            if (!check[this.fishgames[x].games[xx].id]) {
              games.push(this.fishgames[x].games[xx])
              check[this.fishgames[x].games[xx].id] = true
            }
          }
        }
        if (!this.$route.params.provider) {
          this.games = _.orderBy(games, ['gameName'], ['asc'])
        }
      } else if (this.mainMenu === 'provider') {
        this.title = 'เกมส์สล๊อตค่าย'
        if (this.$route.params.provider) {
          this.provider = this.$route.params.provider
        } else {
          this.title = 'เกมส์สล๊อตทั้งหมด'
        }
        const games = []
        const check = []
        let perpage = 100;
        for (const x in this.slotbrands) {
          if (this.$route.params.provider && this.slotbrands[x].provider.trim().toLowerCase() === this.$route.params.provider.trim().toLowerCase()) {
            this.title = 'เกมส์สล๊อตค่าย ' + this.slotbrands[x].providerName
            this.games = _.orderBy(this.slotbrands[x].games, ['gameName'], ['asc'])
            break
          }
          for (const xx in this.slotbrands[x].games) {
            if (!check[this.slotbrands[x].games[xx].id]) {
              games.push(this.slotbrands[x].games[xx])
              check[this.slotbrands[x].games[xx].id] = true
            }
          }
        }
        if (!this.$route.params.provider) {
          const gamesOrder = _.orderBy(games, ['gameName'], ['asc'])
          this.games = gamesOrder.splice(0,(this.page*perpage));
        }
      } else if (this.mainMenu === 'card') {
        this.title = 'เกมส์ไพ่'
        this.games = _.orderBy(this.cardgames, ['gameName'], ['asc'])
      }
    },
    gotoProvider (type, provider) {
      router.replace('/' + type + '/' + provider)
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/')
      }
    },
    nl2br (str, is_xhtml) {
      if (typeof str === 'undefined' || str === null) {
        return ''
      }
      var breakTag =
        is_xhtml || typeof is_xhtml === 'undefined' ? '<br />' : '<br>'
      return (str + '').replace(
        /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
        '$1' + breakTag + '$2'
      )
    }
    // async moveCreditToWallet () {
    //   this.$store.commit('user/SET_LOADING', true)
    //   const user = this.getUserId()
    //   this.$store.dispatch('user/moveCreditToWallet').catch(err => { console.error(err) })
    //   this.$store.dispatch('user/getLastBonus', user).finally(res => {
    //     this.$store.commit('user/SET_LOADING', false)
    //     if (this.lastbonus.turncredit) {
    //       this.$store.commit('user/SET_ALERT_WITHDRAWALL', true)
    //     }
    //   }).catch(err => { console.error(err) })
    // },
  }
}
</script>
<style scoped>
.class-for-mobile {
    display: none;
}
@media only screen and (max-width: 992px) {
    .class-for-mobile {
        display: block; /* หรือตั้งค่าอื่นๆ ที่คุณต้องการ */
    }
}
.bg-mobile2{
  margin-right: 100px;
}
@media screen and (max-width: 992px) {
    .resize {
        width: 899px;
    }
}
@media screen and (max-width: 600px) {
    .resize {
        width: 399px;
    }
    .bg-mobile{
      background-color: #1c1c1c;
    }
    .bg-mobile2{
      margin-right: 0;
    }
}

</style>
